import React, { useState } from 'react';
import Plus from '../../icons/Plus';
import AccordionDetail from './AccordionDetail';
import Minus from '../../icons/Minus';
import './Accordion.css';

interface Props {
  title: string;
  children: React.ReactNode;
}

const Accordion: React.FC<Props> = ({ title, children }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <div className={`accordion ${open ? 'accordion-open' : ''}`}>
      <div
        className="accordion-summary"
        onClick={() => {
          setOpen(!open);
        }}
      >
        <span>{title}</span>

        <div className="accordion-button-wrapper">{open ? <Minus /> : <Plus />}</div>
      </div>

      <AccordionDetail>{children}</AccordionDetail>
    </div>
  );
};

export default Accordion;
